export default "__VITE_ASSET__9kL6vFoA__"